<!--<button [disabled] = "value === false" mat-button (click)="download()"
         class="grid-btn-01">
  {{displayText}}
</button >-->

<!--
<a *ngIf="stepInfo.type !== 'subgroup'" class="link-color" (click)="editStep()">
  {{item.cells[fieldDefinition.key]?.displayText}}
</a>

-->
<div class="tax-forms-compare">
  <div class="flex flex-row flex-wrap justify-between items-center flex-1-0-100">
    <button [disabled]="value === false" mat-button class="grid-button" [matMenuTriggerFor]="menu"
            particleAnalytics
            analyticsCategory="action-type-cell-viewer"
            analyticsAction="action-button">Actions <i class="fas fa-angle-down"></i></button>
    <mat-menu #menu="matMenu">
      <button *ngFor="let menu of menus" mat-menu-item (click)="onClickAction(menu.value)"
              particleAnalytics
              analyticsCategory="action-type-cell-viewer"
              analyticsAction="action-dropdown"
              [analyticsName]="displayText">
        <span>{{menu.title}}</span>
      </button>
    </mat-menu>
  </div>
</div>

